interface IconProps {
  className?: string;
}

const CheckIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 13 12"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10.5 3 5 8.5 2.5 6"
      ></path>
    </svg>
  );
};

export default CheckIcon;
